import { mode } from '@chakra-ui/theme-tools';

const Card = {
  baseStyle: (props) => ({
    p: '24px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: '24px',
    minWidth: '0px',
    wordWrap: 'break-word',
    overflow: 'hidden',
    bg: mode('#ffffff', 'navy.800')(props),
    border: '1px solid',
    borderColor: mode('rgba(17, 24, 18, 0.08)', 'whiteAlpha.200')(props),
    boxShadow: 'none',
    backgroundClip: 'border-box',
  }),
};

export const CardComponent = {
  components: {
    Card,
  },
};
